<template>
  <div>
    <b-row class="my-4">
      <b-col cols="12" lg="6">
        <b-card>
          <h4 slot="header">
            Dane pracownika

            <b-btn
              v-if="$is('hr', 'manager')"
              variant="outline-secondary"
              size="sm"
              target="_blank"
              class="ml-2 float-right"
              :to="{ name: 'timesheet', params: { id: this.$route.params.id }, query: this.$route.query }"
              >Podsumowanie</b-btn
            >
            <b-btn v-if="$is('hr', 'manager')" variant="outline-primary" size="sm" class="float-right" @click="editUser">Edytuj</b-btn>
          </h4>
          
          <table class="w-100">
            <tbody>
              <tr>
                <td class="pt-2 w-50">Imię</td>

                <td class="w-50">{{ user.firstName }}</td>
              </tr>

              <tr>
                <td class="pt-2 w-50">Nazwisko</td>
              
                <td class="w-50">{{ user.lastName }}</td>
              </tr>
              
              <tr>
                <td class="pt-2 w-50">Email</td>
              
                <td class="w-50">{{ user.email }}</td>
              </tr>
              
              <tr>
                <td class="pt-2 w-50">Harmonogram</td>
              
                <td class="w-50">
                  <span v-if="user.currentTimetable && user.currentTimetable.timetable">{{ user.currentTimetable.timetable.name }}</span>
              
                  <b-btn v-if="$is('admin', 'manager', 'hr')" size="sm" class="float-right" variant="outline-primary" @click="showTimetableEdit">Edytuj</b-btn>
                </td>
              </tr>
              
              <tr v-if="$isAdmin()">
                <td class="pt-2 w-50 align-top">Uprawnienia</td>
              
                <td class="w-50">
                  <div class="pt-2 w-100 align-self-top" v-for="{ displayName, id } in user.roles" :key="id">
                    {{ displayName }}
                    <b-btn size="sm" class="float-right" variant="outline-danger" @click="removeUserRole(id)">Usuń</b-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <b-row v-if="$isAdmin()">
            <b-col cols="5">
              <b-form-select class="d-inline-block" size="sm" v-model="selectedRole" :options="roles" />
            </b-col>
          
            <b-col v-if="user" cols="7">
              <b-btn variant="outline-secondary" size="sm" @click="addRole">Dodaj uprawnienie</b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      
      <b-col v-if="user" cols="12" lg="6">
        <b-card>
          <h4 slot="header" @click="tryToShowDaysOff">Karty</h4>
          
          <b-row class="py-1 my-1" v-for="card in user.card" :key="card.id">
            <b-col cols="4">
              <div>Firma</div>
          
              <div>Numer karty</div>
            </b-col>
          
            <b-col cols="4">
              <div>{{ card.company.name }}</div>
          
              <div>{{ card.number }}</div>
            </b-col>
          
            <b-col v-if="$isAdmin()" cols="4" class="text-right">
              <b-dropdown size="sm" split text="Użyj" variant="outline-primary" @click="adminUseCard(card.number)">
                <b-dropdown-item @click="editCard(card)">Edytuj</b-dropdown-item>
          
                <b-dropdown-item @click="removeCard(card.id, card.number)">Usuń</b-dropdown-item>
              </b-dropdown>
            </b-col>
          
            <b-col v-else cols="4" class="text-right">
              <b-btn v-if="card.number.toLowerCase().startsWith('v')" size="sm" variant="outline-primary" @click="useCard(card.number)">Użyj karty</b-btn>
            </b-col>
          
            <b-col cols="12">
              <hr class="my-1" />
            </b-col>
          </b-row>
          
          <b-row v-if="$isAdmin()">
            <b-col class="text-right">
              <b-btn
                variant="outline-primary"
                class="mx-1 my-0"
                size="sm"
                @click="cardSelected = {}; cardModal = true;"
              >
                Dodaj
              </b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <loader :show="showLoader"></loader>

    <button v-if="$is('hr', 'manager')" class="btn btn-sm btn-outline-secondary" @click="showOvertimeModal = true">Ustaw nadgodziny</button>

    <full-calendar
      class="mt-4"
      ref="calendar"
      :config="calendarConfig"
      :events="calendarEvents"
      @view-render="onViewRender"
      @event-created="openNewEventModal"
      @event-selected="openEventModal"
      @event-render="updateEventTitle"
    />

    <period-chart :id="id" />

    <days-off-list v-if="showDaysOff >= 5" />

    <card-modal
      v-if="$isAdmin()"
      :show="cardModal"
      :user="user"
      :card-to-edit="cardSelected"
      @close="cardModal = false"
      @cardEdited="updateCardData"
      @cardAdded="addCard"
    ></card-modal>

    <daysoff-add
      v-if="showEditModal"
      :show="showEditModal"
      :event="selectedEventEdit"
      :isEdit="isEdit"
      :dates="dayOffForm"
      :userId="user.id"
      @submit="saveDayOff"
      @cancel="hideEditModal"
    ></daysoff-add>

    <daysoff-event
      v-if="showEventModal"
      :show="showEventModal"
      :event="selectedEvent"
      :isAdmin="$isAdmin()"
      @edit="openEditModal"
      @cancel="hideEventModal"
      @deny="denyEvent"
      @accept="acceptEvent"
      @absence="acceptAbsenceType"
    ></daysoff-event>

    <workday-edit-modal
      :show="showEditWorkdayModal"
      :workday="selectedWorkday"
      @cancel="hideWorkdayModal"
      @ok="hideWorkdayModal"
      @changed="hideWorkdayModal(true)"
    ></workday-edit-modal>

    <add v-if="addModal" :user="user" :addModal="addModal" @cancel="hideNewEmployeeForm" @edited="updateUserData"></add>

    <timetable-modal :show="showTimetableModal" :userId="id" :timetables="user.timetables" @close="hideTimetableEdit"></timetable-modal>

    <add-workday :show="showAddWorkdayModal" :cardNumber="cardToUse" :startTimetable="user.todayStartTime" @close="hideAdminUseCard" @created="workDayAdd"></add-workday>

    <overtime-modal :show="showOvertimeModal" @close="showOvertimeModal = false" />
  </div>
</template>
<script>
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar/dist/locale/pl';
import moment from 'moment';
import { FullCalendar } from 'vue-full-calendar';

import Add from './modals/Add.vue';
import AddWorkday from './modals/AddWorkday';
import CardModal from './modals/CardModal.vue';
import OvertimeModal from './modals/Overtime.vue';
import TimetableModal from './modals/TimetableModal.vue';
import WorkdayEditModal from './modals/WorkdayEditModal.vue';
import DaysOffList from './helpers/DaysOffList';
import Loader from '../../components/Loader.vue';
import DaysoffEvent from '../calendar/Event.vue';
import DaysoffAdd from '../calendar/Add.vue';
import PeriodChart from '../partials/periodChart.vue';
import { DayEnum } from '@/enums/days.enum';
import { UserResource } from '@/resources/user.resource';
import { CardResource } from '@/resources/card.resource';
import { DayOffResource } from '@/resources/dayOff.resource';
import { RoleResource } from '@/resources/role.resource';
import CalendarService from '@/services/calendar.service';
import authenticationService from '@/services/authentication.service';
import calendarService from '@/services/calendar.service';
import { dayOffService } from '@/services/dayOff.service';
import { toClock } from '@/utils';

// Szczegóły pracownika
export default {
  components: {
    Add,
    AddWorkday,
    CardModal,
    DaysoffAdd,
    DaysoffEvent,
    DaysOffList,
    FullCalendar,
    Loader,
    OvertimeModal,
    PeriodChart,
    TimetableModal,
    WorkdayEditModal
  },
  data() {
    return {
      id: null,
      selectedEventEdit: null,
      calendarConfig: {
        defaultView: 'month',
        editable: false,
        locale: 'pl',
        selectable: true,
        header: {
          left: 'title',
          center: '',
          right: 'prev,next'
        },
        displayEventEnd: true
      },
      calendarEvents: [],
      user: {},
      datesLoaded: [],
      showLoader: true,
      cardModal: false,
      cardSelected: null,
      showEventModal: false,
      roles: [],
      selectedRole: null,
      showEditWorkdayModal: false,
      selectedWorkday: {},
      addModal: false,
      isEdit: true,
      showEditModal: false,
      dayOffForm: {},
      showTimetableModal: false,
      cardToUse: undefined,
      showAddWorkdayModal: false,
      showOvertimeModal: false,
      rawData: undefined,
      showDaysOffClickable: false,
      showDaysOff: 0
    };
  },
  methods: {
    async getUserData() {
      this.user = await UserResource.get(this.id);
      this.showLoader = false;
      this.setCurrentTimetable();
    },
    onViewRender(view) {
      this.setQueryParams(view.intervalStart.year(), view.intervalStart.month() + 1);
    },
    async getCalendarData(year, month, edited) {
      if (!this.id) {
        return;
      }
      if (!year && !month) {
        year = parseInt(this.$route.query.year, 10);
        month = parseInt(this.$route.query.month, 10);
      }
      if (edited) {
        this.calendarEvents = [];
      }
      this.showLoader = true;

      const data = await UserResource.calendar(month, year, this.id);
      this.rawData = data;
      this.showLoader = false;
      this.calendarEvents = [];
      this.convertWorkdaysToEvents(data.workdays);
      this.convertDaysOffToEvents(data.dayoffs);
      this.dayOffEdit = [...data.dayoffs];
      this.convertHolidaysToEvents(data.holidays);
    },
    getDate() {
      return this.$refs.calendar.fireMethod('getDate').toDate();
    },
    convertWorkdaysToEvents(array) {
      const workdayIds = this.calendarEvents.map(item => item.workdayId);
      const events = array
        .filter(workday => !workdayIds.includes(workday.id) && !!workday.start)
        .map(workday => CalendarService.workdayToCalendarEvent(workday));
      this.calendarEvents.push(...events);
    },
    convertDaysOffToEvents(array) {
      const dayOffIds = this.calendarEvents.map(item => item.dayOffId);
      const events = array
        .filter(dayOff => !dayOffIds.includes(dayOff.id))
        .map(dayOff => CalendarService.userDayOffToCalendarEvent(dayOff));
      this.calendarEvents.push(...events);
    },
    convertHolidaysToEvents(array) {
      const holidays = array.map(event => ({
        title: event.name,
        allDay: true,
        start: event.date,
        textColor: '#000000',
        color: event.color,
        rendering: 'background'
      }));
      this.calendarEvents.push(...holidays);
    },
    timeToString(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      return `${toClock(hours)}:${toClock(minutes)}`;
    },
    async removeCard(id, cardNumber) {
      if (!confirm('Czy napewno chcesz usunąć kartę numer: ' + cardNumber)) {
        return;
      }
      await CardResource.delete(id);
      this.$notify({ type: 'success', title: 'Potwierdzenie', text: 'Pomyślnie usunięto kartę' });
      this.user.card.splice(this.user.card.map(card => card.id).indexOf(id), 1);
    },
    addCard(card) {
      this.user.card.push(card);
    },
    updateCardData(card) {
      this.user.card.splice(this.user.card.map(c => c.id).indexOf(card.id), 1, card);
    },
    openNewEventModal(event) {
      this.dayOffForm.dateStart = event.start.toDate();
      this.dayOffForm.dateEnd = event.end.add(-1, 'd').toDate();
      this.selectedWorkday = {};
      this.selectedEvent = null;
      this.selectedEventEdit = null;
      this.showEditModal = true;
    },
    openEventModal(event) {
      if (event.workdayId && authenticationService.is('admin', 'hr', 'manager')) {
        this.showEditWorkdayModal = true;
        this.selectedWorkday = {
          id: event.workdayId,
          start: event.workdayStart,
          end: event.workdayEnd,
          date: event.start.format('DD.MM.YYYY'),
          overtimeLimit: event.overtimeLimit,
          overtimeAccepted: event.overtimeAccepted
        };
      } else if (!event.workdayId) {
        this.showEventModal = true;
        this.selectedEvent = this.calendarEvents.find(e => e.dayOffId === event.dayOffId);
        this.selectedEventEdit = this.dayOffEdit.find(e => e.id === this.selectedEvent.dayOffId);
      }
    },
    hideEventModal() {
      this.showEventModal = false;
    },
    hideWorkdayModal(reloadCalendar = false) {
      this.showEditWorkdayModal = false;
      this.selectedWorkday = {};
      if (reloadCalendar) {
        this.getCalendarData(null, null, true);
      }
    },
    async denyEvent(event) {
      await DayOffResource.deleteDayOff(event.dayOffId);
      this.calendarEvents = this.calendarEvents.filter(e => e.dayOffId !== event.dayOffId);
      this.showEventModal = false;
    },
    async acceptEvent(event) {
      try {
        if (authenticationService.is('admin', 'hr', 'manager')) {
          const data = await DayOffResource.accept(event.dayOffId);
          if (data.accepted === true) {
            this.$set(this.calendarEvents.find(e => e.dayOffId === event.dayOffId), 'accepted', true);
          }
          this.hideEventModal();
        }
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas akceptacji dnia wolnego' });
      }
    },
    async acceptAbsenceType(event, absenceId) {
      try {
        if (this.$is('admin', 'hr')) {
          const acceptResult = await DayOffResource.acceptAbsence(event.dayOffId, absenceId);
          const dbEvent = this.calendarEvents.find(e => e.dayOffId === event.dayOffId);
          this.$set(dbEvent, 'accepted', acceptResult.accepted);
          this.$set(dbEvent, 'hrAccept', true);
          this.showEventModal = false;
        }
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas akceptacji dnia wolnego' });
      }
    },
    async useCard(cardNumber) {
      const result = await CardResource.checkout(cardNumber);
      const time = moment(result.date);
      if (!result.end) {
        time.add(result.start, 'minutes');
        this.$notify({
          type: 'warn',
          title: 'Sukces!',
          text: 'Pomyślnie odnotowano początek pracy o ' + time.format('LT')
        });
      } else if (result.end) {
        time.add(result.end, 'minutes');
        this.$notify({
          type: 'success',
          title: 'Sukces!',
          text: 'Pomyślnie odnotowano koniec pracy o ' + time.format('LT')
        });
      } else {
        this.$notify({ type: 'error', title: 'Błąd!', text: 'Wystąpił błąd.' });
      }
    },
    async addRole() {
      if (!this.selectedRole) {
        return;
      }
      try {
        const { roles } = await RoleResource.addRoleToUser(this.id, this.selectedRole);
        this.user.roles = roles;
        this.$notify({ text: 'Pomyślnie dodano uprawnienie', title: 'Sukces', type: 'success' });
      } catch (error) {
        console.warn(error);
        this.$notify({ text: error.message, type: 'error', title: 'Błąd' });
      }
    },
    async removeUserRole(roleId) {
      try {
        const { roles } = await RoleResource.removeRoleFromUser(this.id, roleId);
        this.user.roles = roles;
        this.$notify({ text: 'Pomyślnie usunięto uprawnienie', title: 'Sukces', type: 'success' });
      } catch (error) {
        this.$notify({ text: error.message, type: 'error', title: 'Błąd' });
      }
    },
    async getRoles() {
      const roles = await RoleResource.list();
      this.roles = roles.map(role => ({ text: role.displayName, value: role.id }));
    },
    // Edycja użytkownika
    editUser() {
      this.user = { ...this.user };
      this.addModal = true;
    },
    updateUserData(user) {
      const id = this.users.map(usr => usr.id).indexOf(user.id);
      this.users.splice(id, 1, { ...user });
      user
        ? this.$notify({ type: 'success', title: 'Edycja pracownika', text: 'Pomyślnie edytowano dane pracownika' })
        : this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas edycji pracownika' });

      this.hideNewEmployeeForm();
    },
    hideNewEmployeeForm() {
      this.addModal = false;
    },
    showTimetableEdit() {
      this.showTimetableModal = true;
    },
    hideTimetableEdit(timetables) {
      this.showTimetableModal = false;
      this.user.timetables = timetables;
      this.setCurrentTimetable();
    },
    // Czyszczenie inputów
    clearInputs() {
      this.user.email = '';
      this.user.firstName = '';
      this.user.lastName = '';
      this.user.password = '';
      this.user.repeatPassword = '';
      this.pass = '';
    },
    openEditModal() {
      this.showEditModal = true;
    },
    hideEditModal() {
      this.showEditModal = false;
    },
    saveDayOff(form, userId, absenceId, id) {
      return dayOffService.save(form, userId, absenceId, id).then(dbEvent => {
        if (id) {
          const dbEventIndex = this.dayOffEdit.find(event => event.id === id);
          this.$set(this.dayOffEdit, dbEventIndex, dbEvent);
          const calendarEvent = this.calendarEvents.find(event => event.dayOffId === id);
          calendarEvent.reason = dbEvent.reason;
          calendarEvent.items = dbEvent.items;
          calendarEvent.absenceId = dbEvent.absenceId;
          return;
        }
        this.dayOffEdit.push(dbEvent);
        this.calendarEvents.push(CalendarService.userDayOffToCalendarEvent(dbEvent));
      });
    },
    loadData() {
      this.id = parseInt(this.$route.params.id, 10);
      const { year, month } = this.$route.query;
      if (!isNaN(year) && !isNaN(month)) {
        this.calendarConfig.defaultDate = moment({ y: year, month: month - 1, d: 1 });
        this.getCalendarData(parseInt(year, 10), parseInt(month, 10));
      }

      this.getUserData();
      this.getRoles();
    },
    setQueryParams(year, month) {
      this.$router.replace({
        query: { year, month }
      });
    },
    setCurrentTimetable() {
      this.user.currentTimetable = this.user.timetables.find(
        item => (item.endDate === null || new Date(item.endDate) > new Date()) && new Date(item.startDate) < new Date()
      );
      if (
        this.user.currentTimetable &&
        this.user.currentTimetable.timetable &&
        this.user.currentTimetable.timetable.name
      ) {
        this.user.todayStartTime =
          this.user.currentTimetable.timetable[DayEnum[new Date().getDay()].toLowerCase()] || 0;
      } else {
        const currentTimetable = { timetable: { name: 'Brak harmonogramu' } };
        this.user.currentTimetable = currentTimetable;
      }
    },
    adminUseCard(cardNumber) {
      this.cardToUse = cardNumber;
      this.showAddWorkdayModal = true;
    },
    hideAdminUseCard() {
      this.cardToUse = undefined;
      this.showAddWorkdayModal = false;
    },
    async workDayAdd(wd) {
      const year = parseInt(this.$route.query.year, 10);
      const month = parseInt(this.$route.query.month, 10);
      const { workdays } = await UserResource.workdays(month, year, this.id);
      this.convertWorkdaysToEvents(workdays);
    },
    updateEventTitle(event, element, view) {
      if (event.rendering === 'background') {
        element.append(event.title);
      } else if (!event.workdayId) {
        calendarService.showDayOffPopup(event, element, this.$root);
      }
      calendarService.prependDayOffIcons(event, element);
    },
    editCard(card) {
      this.cardSelected = {
        number: card.number,
        companyName: card.company.name,
        cardId: card.id,
        id: this.id,
        companyId: card.company.id
      };
      this.cardModal = true;
    },
    tryToShowDaysOff() {
      if (this.showDaysOffClickable) {
        this.showDaysOff++;
      } else {
        this.showDaysOffClickable = true;
        this.showDaysOff++;
        setTimeout(() => {
          this.showDaysOffClickable = false;
          if (this.showDaysOff < 5) {
            this.showDaysOff = 0;
          }
        }, 1000);
      }
    }
  },
  watch: {
    $route(to, from) {
      if (!to.query.year || !to.query.month) {
        const now = new Date();
        return this.setQueryParams(now.getFullYear(), now.getMonth() + 1);
      }
      this.loadData();
    }
  },
  beforeMount() {
    this.loadData();
  }
};
</script>
<style>
.office.accepted {
  background-color: #29a847;
  border-color: #29a847;
}
.office.accepted.other-person {
  background-color: rgba(41, 168, 71, 0.31);
}
.office.accepted.other-person > .fc-content > .fc-title {
  background-color: #29a847;
}
.office.not-accepted {
  background-color: #ffc107;
  border-color: #ffc107;
}
.office.not-accepted.other-person {
  background-color: rgba(255, 193, 7, 0.314);
}
.office.not-accepted.other-person > .fc-content > .fc-title {
  background-color: #ffc107;
}
.home-office.accepted {
  background-color: #06f;
  border-color: #06f;
}
.home-office.accepted.other-person {
  background-color: rgba(0, 102, 255, 0.31);
}
.home-office.accepted.other-person > .fc-content > .fc-title {
  background-color: #06f;
}
.home-office.not-accepted {
  background-color: #4d5472;
  border-color: #4d5472;
}
.home-office.not-accepted.other-person {
  background-color: rgba(77, 84, 114, 0.314);
}
.home-office.not-accepted.other-person > .fc-content > .fc-title {
  background-color: #4d5472;
}
.fc-content {
  cursor: pointer;
  background: inherit;
}
.fc-content > .fc-title {
  background: inherit;
  -webkit-background-clip: text;
  color: transparent;
  filter: invert(1) grayscale(1) contrast(100);
}
.fc-content > .fc-title > i {
  background: inherit !important;
}
</style>
